import { Component, OnInit, Provider } from '@angular/core';
import { CloseGuard, DialogRef, ModalComponent } from 'ngx-modialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../utils/services/api.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { ProviderItem } from '../../../utils/objects/organization-parameter';
import {
  HOTEL_PROVIDERS,
  FLIGHT_PROVIDERS,
  PROVIDER_FIELDS,
  PROVIDER_TYPES,
  PACKAGE_PROVIDERS,
  CHANNEL_MANAGER_PROVIDERS, 
  AUTOCOMPLETE_PROVIDERS,
  RENTING_PROVIDERS
} from '../../../utils/constants/constants';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-flight-provider-info',
  templateUrl: './flight-provider-info.component.html',
  styleUrls: ['./flight-provider-info.component.css']
})

export class FlightProviderInfoComponent implements OnInit, CloseGuard, ModalComponent<any> {

  public organizationParameterForm: FormGroup;
  public providerItem;
  public isAgencyView;
  public organizationID;
  public providers = FLIGHT_PROVIDERS;
  public types = PROVIDER_TYPES;
  public selectedProvider;
  public selectedType;
  validationFields = {
    'bizipackage': ['baseURL'],
    'bizihotel': ['baseURL'],
    'paximum': ['baseURL', 'appToken']
  }
  requiredDummyValueFields = {
    'tourvisio': ['baseURL'],
    'tourvisioHotel': ['baseURL'],
    'tourvisioAutocomplete': ['baseURL'],
    'tourvisioRenting': ['baseURL'],
  }
  constructor(public dialog: DialogRef<any>,
    private apiService: ApiService,
    private notificationsService: NotificationsService) {
    this.organizationID = this.dialog.context.organizationID;
    this.providerItem = this.dialog.context.providerItem;
    this.isAgencyView = this.dialog.context.isAgencyView;
    dialog.setCloseGuard(this);
  }

  ngOnInit() {
    this.organizationParameterForm = new FormGroup({
      'type': new FormControl(null),
      'provider': new FormControl(null),
      'username': new FormControl(null),
      'password': new FormControl(null),
      'serviceURL': new FormControl(null),
      'serviceKey': new FormControl(null),
      'apiKey': new FormControl(null),
      'secret': new FormControl(null),
      'PseudoCityCode': new FormControl(null),
      'AgentDutyCode': new FormControl(null),
      'infoSource': new FormControl(null),
      'serviceUrl': new FormControl(null),
      'TRY': new FormControl(null),
      'USD': new FormControl(null),
      'EUR': new FormControl(null),
      'company': new FormControl(null),
      'baseURL': new FormControl(null),
      'ShowUseCompanyPrice': new FormControl(false),
      'appToken': new FormControl(null)
    });
    if (this.providerItem) {
      this.selectedProvider = this.dialog.context.providerItem.provider;
      this.selectedType = this.dialog.context.providerItem.type;
      if (this.selectedType === 'FlightProvider') {
        this.providers = FLIGHT_PROVIDERS;
      }
      else if (this.selectedType === 'PackageProvider') {
        this.providers = PACKAGE_PROVIDERS;
      }
      else if (this.selectedType === 'HotelProvider') {
        this.providers = HOTEL_PROVIDERS;
      }
      else if (this.selectedType === 'RentingProvider') {
        this.providers = RENTING_PROVIDERS;
      }
      else if (this.selectedType === 'ChannelManagerProvider') {
        this.providers = CHANNEL_MANAGER_PROVIDERS;
      }
      else {
        this.providers = AUTOCOMPLETE_PROVIDERS;
      }
      this.organizationParameterForm.controls.type.patchValue(this.selectedType);
      this.organizationParameterForm.controls.provider.patchValue(this.providerItem.provider);
      if(this.providerItem.baseURL && !this.providerItem.baseURL.encrypted) {
        this.organizationParameterForm.controls.baseURL.patchValue(this.providerItem.baseURL.value);
      }
      if(this.providerItem.serviceURL && !this.providerItem.serviceURL.encrypted) {
        this.organizationParameterForm.controls.serviceURL.patchValue(this.providerItem.serviceURL.value);
      }
      if(this.providerItem.apiKey && !this.providerItem.apiKey.encrypted) {
        this.organizationParameterForm.controls.apiKey.patchValue(this.providerItem.apiKey.value);
      }
      if(this.providerItem.secret && !this.providerItem.secret.encrypted) {
        this.organizationParameterForm.controls.secret.patchValue(this.providerItem.secret.value);
      }
      if(this.providerItem.PseudoCityCode && !this.providerItem.PseudoCityCode.encrypted) {
        this.organizationParameterForm.controls.PseudoCityCode.patchValue(this.providerItem.PseudoCityCode.value);
      }
      if(this.providerItem.AgentDutyCode && !this.providerItem.AgentDutyCode.encrypted) {
        this.organizationParameterForm.controls.AgentDutyCode.patchValue(this.providerItem.AgentDutyCode.value);
      }
      if(this.providerItem.infoSource && !this.providerItem.infoSource.encrypted) {
        this.organizationParameterForm.controls.infoSource.patchValue(this.providerItem.infoSource.value);
      }
      if(this.providerItem.company && !this.providerItem.company.encrypted) {
        this.organizationParameterForm.controls.company.patchValue(this.providerItem.company.value);
      }
      if(this.providerItem.TRY && !this.providerItem.TRY.encrypted) {
        this.organizationParameterForm.controls.TRY.patchValue(this.providerItem.TRY.value);
      }
      if(this.providerItem.USD && !this.providerItem.USD.encrypted) {
        this.organizationParameterForm.controls.USD.patchValue(this.providerItem.USD.value);
      }
      if(this.providerItem.EUR && !this.providerItem.EUR.encrypted) {
        this.organizationParameterForm.controls.EUR.patchValue(this.providerItem.EUR.value);
      }
      if(this.providerItem.appToken && !this.providerItem.appToken.encrypted) {
        this.organizationParameterForm.controls.appToken.patchValue(this.providerItem.appToken.value);
      }
      this.organizationParameterForm.controls.ShowUseCompanyPrice.patchValue(this.providerItem.ShowUseCompanyPrice ? (this.providerItem.ShowUseCompanyPrice.value != 0 && this.providerItem.ShowUseCompanyPrice.value != 'false') : false);
    } else {
      this.setForm();
    }
  }

  closeModal() {
    this.dialog.close();
  }

  beforeDismiss(): boolean {
    return true;
  }

  beforeClose(): boolean {
    return false;
  }

  saveFlightProvider() {
    let requests: Array<Observable<any>> = [];
    let showUseCompanyPriceIndex = PROVIDER_FIELDS[this.selectedType][this.selectedProvider].findIndex(item => item === 'ShowUseCompanyPrice');
    if (showUseCompanyPriceIndex > -1 && this.isAgencyView) {
      PROVIDER_FIELDS[this.selectedType][this.selectedProvider].splice(showUseCompanyPriceIndex, 1);
    }
    if (this.providerItem) {
      PROVIDER_FIELDS[this.selectedType][this.selectedProvider].forEach((key) => {
        if (this.organizationParameterForm.controls[key].value) {
          if (this.providerItem[key]) {
            requests.push(this.createPutRequest(this.providerItem[key].id, this.selectedProvider,
              key, this.organizationParameterForm.controls[key].value, this.organizationParameterForm.controls.type.value));
          } else {
            requests.push(this.createPostRequest(this.organizationParameterForm.controls.provider.value,
              key, this.organizationParameterForm.controls[key].value, this.organizationParameterForm.controls.type.value));
          }
        }
      });
    }
    else {
      PROVIDER_FIELDS[this.selectedType][this.selectedProvider].forEach((key) => {
        if (this.organizationParameterForm.controls[key].value) {
          requests.push(this.createPostRequest(this.organizationParameterForm.controls.provider.value,
            key, this.organizationParameterForm.controls[key].value, this.organizationParameterForm.controls.type.value));
        }
      });

    }

    Observable.forkJoin(requests).subscribe(
      response => {
        this.notificationsService.success('Success', 'Provider is added');
        this.dialog.close(response);
      }, error => {
        this.notificationsService.error('Error', 'Error occured');
      }
    );

  }

  createPostRequest(context, key, value, type): Observable<any> {
    const isProvider = this.apiService.getOrganizationParameters(this.organizationID)
    return this.apiService.addOrganizationParameter(this.organizationID, {
      type,
      context,
      key,
      value
    });
  }

  createPutRequest(parameterID: number, context, key, value, type): Observable<any> {
    return this.apiService.updateOrganizationParameter(this.organizationID, parameterID, {
      type,
      context,
      key,
      value
    });
  }
  setType() {
    this.selectedType = this.organizationParameterForm.value.type;
    this.organizationParameterForm.controls.provider.patchValue(null);
    this.setNullValidators();
    this.selectedProvider = null;
    if (this.selectedType === 'FlightProvider') {
      this.providers = FLIGHT_PROVIDERS;
    } else if (this.selectedType === 'PackageProvider') {
      this.providers = PACKAGE_PROVIDERS;
    }
    else if (this.selectedType === 'HotelProvider') {
      this.providers = HOTEL_PROVIDERS;
    }
    else if (this.selectedType === 'RentingProvider') {
      this.providers = RENTING_PROVIDERS;
    }
    else if (this.selectedType === 'ChannelManagerProvider') {
      this.providers = CHANNEL_MANAGER_PROVIDERS;
    }
    else {
      this.providers = AUTOCOMPLETE_PROVIDERS;
    }
  }
  setForm() {
    this.selectedProvider = this.organizationParameterForm.value.provider;
    if(this.selectedProvider && this.requiredDummyValueFields[this.selectedProvider]) {
      this.requiredDummyValueFields[this.selectedProvider].forEach(field => {
        this.organizationParameterForm.controls[field].patchValue(true);
      })
    }
    if (this.selectedProvider && this.validationFields[this.selectedProvider]) {
      this.setNullValidators();
      this.validationFields[this.selectedProvider].forEach(field => {
        this.organizationParameterForm.controls[field].setValidators(Validators.required);
        if (!this.organizationParameterForm.controls[field].value)
          this.organizationParameterForm.controls[field].setErrors({ required: true });
      })
    } else {
      this.setNullValidators();
    }
  }

  setNullValidators() {
    this.organizationParameterForm.controls['username'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['username'].setErrors(null);
    this.organizationParameterForm.controls['password'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['password'].setErrors(null);
    this.organizationParameterForm.controls['serviceURL'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['serviceURL'].setErrors(null);
    this.organizationParameterForm.controls['serviceKey'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['serviceKey'].setErrors(null);
    this.organizationParameterForm.controls['baseURL'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['baseURL'].setErrors(null);
    this.organizationParameterForm.controls['PseudoCityCode'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['PseudoCityCode'].setErrors(null);
    this.organizationParameterForm.controls['apiKey'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['apiKey'].setErrors(null);
    this.organizationParameterForm.controls['AgentDutyCode'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['AgentDutyCode'].setErrors(null);
    this.organizationParameterForm.controls['infoSource'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['infoSource'].setErrors(null);
    this.organizationParameterForm.controls['secret'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['secret'].setErrors(null);
    this.organizationParameterForm.controls['TRY'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['TRY'].setErrors(null);
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/flight-provider-info/flight-provider-info.component.ts